module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAANJJREFUOI2tUskRgzAMlJImgFdKkG3+OJUZKgv8c7iLUAXKIxyeAQszw7409nq1KwvgJFylSyLtsrxos7ywWZbf+v7bxbgXSQQAwH9eCIxNeHYIpAynnO06Ooq4EHMdRhnrNkZHqQsp8xhLCwAtMDbeP6NiIohKm8KbHf0fDNWxNpduchjMaKgAsU7WkLhE2qXsCpF2wfwiJGVYEiMq7dY+rb+fuRZtIztgvItulq7bEZMirR4pw+HXxyJNEDcbkBdXO5HkzSbt5nkx196/G4l/Cn76N0uo05urfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliIdentity.png
// module id = J/H9
// module chunks = 1